<!-- US-CHIP-TUNING-SILDER-SEARCH-BY-VECH-DESIGN -->
<ng-container *ngIf="showVehicleSearch ; else underSlider">
  <section class="onslider-shop-by-vechicle  row">
    <div class="vehicle-banner col-md-8">
      <p class="banner-title mt-2">Shop By Vehicle</p>
      <div class="select-group my-3">
        <select class="vehicle-select  form-select" id="vehicle_make1" name="vehicle_make" [(ngModel)]="selectedMakeKey"
          (ngModelChange)="onSelectMake()"
          [ngClass]="{'select-form': true,'active-next': !selectedMakeKey, 'completed': selectedMakeKey}">
          <option value="">Make</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_make']">
            {{ makes[selectedMakeKey] }}
          </option>
          <option *ngFor="let make of makes | sortByValue" [value]="make?.key">
            {{make?.value}}
          </option>
        </select>
      </div>
      <div class="select-group my-3">
        <select class="vehicle-select form-select" [(ngModel)]="selectedModelKey" (ngModelChange)="onSelectModel()"
          [ngClass]="{
                  'active-next': selectedMakeKey && !selectedModelKey,
                  'completed': selectedModelKey }">
          <option value="">Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_model']">
            {{ models[selectedModelKey] }}
          </option>
          <option *ngFor="let model of models | sortByValue " [value]="model?.key">
            {{model?.value}}
          </option>
        </select>
        <input type="hidden" name="vehicle_model_name" id="vehicle_model_name" value="" />
      </div>
      <div class="select-group my-3  ">
        <select class="vehicle-select form-select" [(ngModel)]="selectedYearKey" (ngModelChange)="onSelectYear()"
          [ngClass]="{
                   'active-next': selectedModelKey && !selectedYearKey,
                   'completed': selectedYearKey }">
          <option value="">Year</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_year']">
            {{ years[selectedYearKey] }}
          </option>
          <option *ngFor="let year of years| keyvalue:yearsDesc" [value]="year.key">
            {{year.value}}
          </option>
        </select>
      </div>
      <div *ngIf="showSubmodel1 == true" class="select-group my-3">
        <select class="vehicle-select  form-select active-next" name="vehicle_sub_model1" [(ngModel)]="selectedSubmodel1Key"
          (ngModelChange)="onSelectSubmodel1()"   [ngClass]="{'completed': selectedSubmodel1Key }">
          <option value="">Sub Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_1']">
            {{ submodels1[selectedSubmodel1Key] }}
          </option>
          <option *ngFor="let submodel1 of submodels1| keyvalue" [value]="submodel1.key">
            {{submodel1.value}}
          </option>
        </select>
      </div>
      <div *ngIf="showSubmodel2 == true" name="vehicle_sub_model2" class="select-group my-3">
        <select class="vehicle-select  form-select active-next" [(ngModel)]="selectedSubmodel2Key"
          (ngModelChange)="onSelectSubmodel2()"   [ngClass]="{'completed': selectedSubmodel2Key }">
          <option value="">Sub Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_2']">
            {{ submodels2[selectedSubmodel2Key] }}
          </option>
          <option *ngFor="let submodel2 of submodels2| keyvalue" [value]="submodel2.key">
            {{submodel2.value}}
          </option>
        </select>
      </div>
      <div *ngIf="showSubmodel3 == true" class="select-group my-3">
        <select class="vehicle-select  form-select active-next" name="vehicle_sub_model3" [(ngModel)]="selectedSubmodel3Key"
          (ngModelChange)="onSelectSubmodel3()"   [ngClass]="{'completed': selectedSubmodel3Key }">
          <option value="">Sub Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_3']">
            {{ submodels3[selectedSubmodel3Key] }}
          </option>
          <option *ngFor="let submodel3 of submodels3| keyvalue" [value]="submodel3.key">
            {{submodel3.value}}
          </option>
        </select>
      </div>
      <ng-container *ngIf="showCategory">
        <div class="select-group my-3" *ngFor="let dropdown of mmysubCategoriesDropDownData; let i = index">
          <select name="{{dropdown.selected}}" class="vehicle-select form-select" [(ngModel)]="dropdown.selected"
            (change)="fetchSubCategoryData(dropdown,i)"   [ngClass]="{'completed': dropdown.selected }">
            <option value=""> Category</option>
            <option *ngFor="let category of dropdown?.data" [value]="category.category_key">
              {{category.name}}
            </option>
          </select>
        </div>
      </ng-container>
      <div class="banner-actions my-3 d-flex ">
        <button class="clear-red-btn" type="button" (click)="clearVehicle()">Clear</button>
        <button type="button" class="btn-red-go" [disabled]="isSearchDisabled()" (click)="onSearchVehicle()">GO <img *ngIf="!chTheme14"
            src="/assets/images/uschiptuning/red-next-img.png" class="img-fluid ps-2" alt="icon"> </button>
      </div>
    </div>
  </section>
</ng-container>

<!-- texasmustang -->

<ng-template #underSlider>
 <div  class="container custom_container texas-search">
<ng-container *ngIf="showVehicleSearchSlider; else vehiclePopup">
<section class="onslider-shop-by-vechicle  row">
  <p class="banner-title mt-2 text-center text-uppercase">Shop parts that fit your vehicle</p>
    <div class="vehicle-banner col-md-12 d-flex justify-content-center  align-items-center">
        <div class="select-group col-md-3 col-lg-3 col-xxl-2">
        <select class="vehicle-select  form-select" id="vehicle_make1" name="vehicle_make" [(ngModel)]="selectedMakeKey"
          (ngModelChange)="onSelectMake()"
          [ngClass]="{'select-form': true,'active-next': !selectedMakeKey, 'completed': selectedMakeKey}">
          <option value="">Make</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_make']">
            {{ makes[selectedMakeKey] }}
          </option>
          <option *ngFor="let make of makes | sortByValue" [value]="make?.key">
            {{make?.value}}
          </option>
        </select>
      </div>
      <div class="select-group col-md-3 col-lg-3 col-xxl-2">
        <select class="vehicle-select form-select" [(ngModel)]="selectedModelKey" (ngModelChange)="onSelectModel()"
          [ngClass]="{
                  'active-next': selectedMakeKey && !selectedModelKey,
                  'completed': selectedModelKey }">
          <option value="">Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_model']">
            {{ models[selectedModelKey] }}
          </option>
          <option *ngFor="let model of models | sortByValue " [value]="model?.key">
            {{model?.value}}
          </option>
        </select>
        <input type="hidden" name="vehicle_model_name" id="vehicle_model_name" value="" />
      </div>
      <div class="select-group  col-md-3 col-lg-3 col-xxl-2">
        <select class="vehicle-select form-select" [(ngModel)]="selectedYearKey" (ngModelChange)="onSelectYear()"
          [ngClass]="{
                   'active-next': selectedModelKey && !selectedYearKey,
                   'completed': selectedYearKey }">
          <option value="">Year</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_year']">
            {{ years[selectedYearKey] }}
          </option>
          <option *ngFor="let year of years| keyvalue:yearsDesc" [value]="year.key">
            {{year.value}}
          </option>
        </select>
      </div>
      <div *ngIf="showSubmodel1 == true" class="select-group col-2">
        <select class="vehicle-select  form-select active-next" name="vehicle_sub_model1" [(ngModel)]="selectedSubmodel1Key"
          (ngModelChange)="onSelectSubmodel1()"   [ngClass]="{'completed': selectedSubmodel1Key }">
          <option value="">Sub Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_1']">
            {{ submodels1[selectedSubmodel1Key] }}
          </option>
          <option *ngFor="let submodel1 of submodels1| keyvalue" [value]="submodel1.key">
            {{submodel1.value}}
          </option>
        </select>
      </div>
      <div *ngIf="showSubmodel2 == true" name="vehicle_sub_model2" class="select-group">
        <select class="vehicle-select  form-select active-next" [(ngModel)]="selectedSubmodel2Key"
          (ngModelChange)="onSelectSubmodel2()"   [ngClass]="{'completed': selectedSubmodel2Key }">
          <option value="">Sub Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_2']">
            {{ submodels2[selectedSubmodel2Key] }}
          </option>
          <option *ngFor="let submodel2 of submodels2| keyvalue" [value]="submodel2.key">
            {{submodel2.value}}
          </option>
        </select>
      </div>
      <div *ngIf="showSubmodel3 == true" class="select-group">
        <select class="vehicle-select  form-select active-next" name="vehicle_sub_model3" [(ngModel)]="selectedSubmodel3Key"
          (ngModelChange)="onSelectSubmodel3()"   [ngClass]="{'completed': selectedSubmodel3Key }">
          <option value="">Sub Model</option>
          <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_3']">
            {{ submodels3[selectedSubmodel3Key] }}
          </option>
          <option *ngFor="let submodel3 of submodels3| keyvalue" [value]="submodel3.key">
            {{submodel3.value}}
          </option>
        </select>
      </div>
      <ng-container *ngIf="showCategory">
        <div class="select-group" *ngFor="let dropdown of mmysubCategoriesDropDownData; let i = index">
          <select name="{{dropdown.selected}}" class="vehicle-select form-select" [(ngModel)]="dropdown.selected"
            (change)="fetchSubCategoryData(dropdown,i)"   [ngClass]="{'completed': dropdown.selected }">
            <option value=""> Category</option>
            <option *ngFor="let category of dropdown?.data" [value]="category.category_key">
              {{category.name}}
            </option>
          </select>
        </div>
      </ng-container>
      <div class="banner-actions my-3 d-flex ">
        <button class="clear-red-btn" type="button" (click)="clearVehicle()">Clear</button>
        <button type="button" class="btn-red-go" [disabled]="isSearchDisabled()" (click)="onSearchVehicle()">Search </button>
      </div>
    </div>
  </section>
</ng-container>
</div>
</ng-template>

<!-- Default SEARCH-BY-VECH popup -->
<ng-template #vehiclePopup>
  <!-- KARLS-SHOP-VECH-POPUP -->
  <div class="modal popup-form-wrapper fade show d-block" tabindex="-1" role="dialog"
  aria-labelledby="searchByVehicleLabel" aria-modal="true" *ngIf="!chTheme4 && !chTheme12 && !chTheme13 && !chTheme14 && !chTheme15">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content mt-0" appClickOutside (clickedOutside)="clickOutsideBox($event)">
        <div class="modal-header p-0 d-block border-0 justify-content-center">
          <div class="search-by-head">
            <h1 class="text-center pt-1 pb-2">
              Shop By
              <img *ngIf="showFeaturedLogo == 'true'" [src]="imgBasePath + 'mcLeod_header_center_img.webp'"
                alt="header-img" class="img-fluid" />
              <span>Vehicle</span>
            </h1>
          </div>
          <button type="button" class="btn-close position-absolute end-0 top-0 m-2" data-bs-dismiss="modal"
            aria-label="Close" mat-dialog-close></button>
        </div>
        <div class="modal-body search-form-wrapper">
          <form>
            <div class="row g-3 d-flex flex-column align-item-start justify-content-start">
              <div class="col-12 text-center">
                <div class="select-wrap step-1">
                  <span class="step-number">1</span>
                  <select size="1" id="vehicle_make1" name="vehicle_make" [attr.title]="makes[selectedMakeKey]"
                    class="form-select form-control select-form no-1-img  no-focus ps-5" [(ngModel)]="selectedMakeKey"
                    (ngModelChange)="onSelectMake()"
                    [ngClass]="{'select-form': true,'active-next': !selectedMakeKey,  'completed': selectedMakeKey }">
                    <option value="">Select Make</option>
                    <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_make']">
                      {{ makes[selectedMakeKey] }}
                    </option>
                    <option *ngFor="let make of makes | sortByValue" [value]="make?.key">
                      {{make?.value}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-12 text-center">
                <div class="select-wrap step-2">
                  <span class="step-number">2</span>
                  <select name="vehicle_model" size="1" [attr.title]="models[selectedModelKey]"
                    class="form-select gif-form no-focus no-2-icon drop-img ps-5 step step-2"
                    [(ngModel)]="selectedModelKey" (ngModelChange)="onSelectModel()" [ngClass]="{
                  'no-2-icon': true,
                  'active-next': selectedMakeKey && !selectedModelKey,
                  'completed': selectedModelKey }">
                    <option value="">Select Model</option>
                    <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_model']">
                      {{ models[selectedModelKey] }}
                    </option>
                    <option *ngFor="let model of models | sortByValue " [value]="model?.key">
                      {{model?.value}}
                    </option>
                  </select>
                </div>
                <input type="hidden" name="vehicle_model_name" id="vehicle_model_name" value="" />
              </div>
              <div class="col-12 text-center ">
                <div class="select-wrap step-3">
                  <span class="step-number">3</span>
                  <select name="vehicle_year" size="1" [attr.title]="years[selectedYearKey]"
                    class="form-select form-control no-focus no-3-icon gif-form drop-img ps-5 step step-3"
                    [(ngModel)]="selectedYearKey" (ngModelChange)="onSelectYear()" [ngClass]="{
                    'no-3-icon': true,
                   'active-next': selectedModelKey && !selectedYearKey,
                   'completed': selectedYearKey }">
                    <option value="">Select Year</option>
                    <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_year']">
                      {{ years[selectedYearKey] }}
                    </option>
                    <option *ngFor="let year of years| keyvalue:yearsDesc" [value]="year.key">
                      {{year.value}}
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="showSubmodel1 == true" class="col-12 text-center ">
                <div class="select-wrap">
                  <span class="step-number">4</span>
                  <select name="vehicle_sub_model1" size="1" [attr.title]="submodels1[selectedSubmodel1Key]"
                    class="form-select select-form gif-form form-control no-focus ps-5"
                    [(ngModel)]="selectedSubmodel1Key" (ngModelChange)="onSelectSubmodel1()" [ngClass]="{'completed': selectedSubmodel1Key }">
                    <option value="">Select Sub Model</option>
                    <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_1']">
                      {{ submodels1[selectedSubmodel1Key] }}
                    </option>
                    <option *ngFor="let submodel1 of submodels1| keyvalue" [value]="submodel1.key">
                      {{submodel1.value}}
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="showSubmodel2" class="col-12 text-center ">
                <div class="select-wrap">
                  <span class="step-number">5</span>
                  <select size="1" name="vehicle_sub_model2" [attr.title]="submodels2[selectedSubmodel2Key]"
                    class="form-select select-form gif-form form-control no-focus ps-5"
                    [(ngModel)]="selectedSubmodel2Key" (ngModelChange)="onSelectSubmodel2()" [ngClass]="{'completed': selectedSubmodel2Key }">
                    <option value="">Select Sub Model</option>
                    <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_2']">
                      {{ submodels2[selectedSubmodel2Key] }}
                    </option>
                    <option *ngFor="let submodel2 of submodels2| keyvalue" [value]="submodel2.key">
                      {{submodel2.value}}
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="showSubmodel3" class="col-12 text-center ">
                <div class="select-wrap">
                  <span class="step-number">6</span>
                  <select size="1" name="vehicle_sub_model3" [attr.title]="submodels3[selectedSubmodel3Key]"
                    class="form-select select-form gif-form form-control no-focus ps-5"
                    [(ngModel)]="selectedSubmodel3Key" (ngModelChange)="onSelectSubmodel3()" [ngClass]="{'completed': selectedSubmodel3Key }">
                    <option value="">Select Sub Model</option>
                    <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_3']">
                      {{ submodels3[selectedSubmodel3Key] }}
                    </option>
                    <option *ngFor="let submodel3 of submodels3 | keyvalue" [value]="submodel3.key">
                      {{submodel3.value}}
                    </option>
                  </select>
                </div>
              </div>
              <ng-container *ngIf="showCategory">
                <div class="col-12 text-center " *ngFor="let dropdown of mmysubCategoriesDropDownData; let i = index">
                  <div class="select-wrap">
                    <span class="step-number">{{dropdown.id}}</span>
                    <select name="{{dropdown.selected}}" size="1"
                      class="form-select select-form gif-form form-control no-focus ps-5"
                      [(ngModel)]="dropdown.selected" (change)="fetchSubCategoryData(dropdown,i)">
                      <option value="">Select Category</option>
                      <option *ngFor="let category of dropdown?.data" [value]="category.category_key">
                        {{category.name}}
                      </option>
                    </select>
                  </div>
                </div>
              </ng-container>
              <div class="bg-black-buttons d-flex justify-content-start flex-column gap-2 px-2 mb-0">
                <button type="button" class="btn search-btn btn-lg" (click)="onSearchVehicle()"
                  [ngClass]="{'opacity-04': isSearchDisabled()}" [disabled]="isSearchDisabled()">
                  Search Parts
                  <img [src]="commonImagePath+'search-pop.webp'" class="ms-2 popup-search-icon">
                </button>
                <button *ngIf="showClearButton" type="button" class="btn clear-btn btn-lg" (click)="clearVehicle()">
                  Clear Vehicle
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


  <!-- US-CHIP-TUNING-SHOP-VECH-POPUP -->
  <div class=" color-bg modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="searchByVehicleLabel"
    aria-modal="true" *ngIf="chTheme4 || chTheme12 || chTheme13 || chTheme14  || chTheme15">
    <div class="modal-dialog chip-popup" role="document">
      <div class="modal-content" appClickOutside (clickedOutside)="clickOutsideBox($event)">
        <section class="onslider-shop-by-vechicle  row">
          <div class="vehicle-us-banner col-md-8">
            <p class="banner-title d-flex justify-content-between mt-2 align-items-center">Shop By Vehicle
              <!-- <i class="fa-solid fa-xmark"></i> -->
             <button type="button" class="btn-white-close m-2" data-bs-dismiss="modal"
            aria-label="Close" mat-dialog-close><i class="fa-solid fa-xmark"></i></button>
            </p>
            <div class="select-group my-3">
              <select  [attr.title]="makes[selectedMakeKey]" class="vehicle-select  form-select" id="vehicle_make1" name="vehicle_make"
                [(ngModel)]="selectedMakeKey" (ngModelChange)="onSelectMake()"
                [ngClass]="{'select-form': true,'active-next': !selectedMakeKey, 'completed': selectedMakeKey}">
                <option value="">Make</option>
                <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_make']">
                  {{ makes[selectedMakeKey] }}
                </option>
                <option *ngFor="let make of makes | sortByValue" [value]="make?.key">
                  {{make?.value}}
                </option>
              </select>
            </div>
            <div class="select-group my-3">
              <select [attr.title]="models[selectedModelKey]"  class="vehicle-select form-select" [(ngModel)]="selectedModelKey"
                (ngModelChange)="onSelectModel()" [ngClass]="{
                  'active-next': selectedMakeKey && !selectedModelKey,
                  'completed': selectedModelKey }">
                <option value="">Model</option>
                <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_model']">
                  {{ models[selectedModelKey] }}
                </option>
                <option *ngFor="let model of models | sortByValue " [value]="model?.key">
                  {{model?.value}}
                </option>
              </select>
              <input type="hidden" name="vehicle_model_name" id="vehicle_model_name" value="" />
            </div>
            <div class="select-group my-3  ">
              <select  [attr.title]="years[selectedYearKey]"  class="vehicle-select form-select" [(ngModel)]="selectedYearKey" (ngModelChange)="onSelectYear()"
                [ngClass]="{
                   'active-next': selectedModelKey && !selectedYearKey,
                   'completed': selectedYearKey }">
                <option value="">Year</option>
                <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['select_year']">
                  {{ years[selectedYearKey] }}
                </option>
                <option *ngFor="let year of years| keyvalue:yearsDesc" [value]="year.key">
                  {{year.value}}
                </option>
              </select>
            </div>
            <div *ngIf="showSubmodel1 == true" class="select-group my-3">
              <select class="vehicle-select  form-select active-next" name="vehicle_sub_model1" [(ngModel)]="selectedSubmodel1Key"
                (ngModelChange)="onSelectSubmodel1()" [ngClass]="{'completed': selectedSubmodel1Key }">
                <option value="">Sub Model</option>
                <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_1']">
                  {{ submodels1[selectedSubmodel1Key] }}
                </option>
                <option *ngFor="let submodel1 of submodels1| keyvalue" [value]="submodel1.key">
                  {{submodel1.value}}
                </option>
              </select>
            </div>
            <div *ngIf="showSubmodel2 == true" name="vehicle_sub_model2" class="select-group my-3">
              <select class="vehicle-select  form-select" [(ngModel)]="selectedSubmodel2Key"
                (ngModelChange)="onSelectSubmodel2()"[ngClass]="{'completed': selectedSubmodel2Key }">
                <option value="">Sub Model</option>
                <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_2']">
                  {{ submodels2[selectedSubmodel2Key] }}
                </option>
                <option *ngFor="let submodel2 of submodels2| keyvalue" [value]="submodel2.key">
                  {{submodel2.value}}
                </option>
              </select>
            </div>
            <div *ngIf="showSubmodel3 == true" class="select-group my-3">
              <select class="vehicle-select  form-select" name="vehicle_sub_model3" [(ngModel)]="selectedSubmodel3Key"
                (ngModelChange)="onSelectSubmodel3()" [ngClass]="{'completed': selectedSubmodel3Key }">
                <option value="">Sub Model</option>
                <option *ngIf="mmyDataExists" [value]="mmyDropDownData?.['sub_model_3']">
                  {{ submodels3[selectedSubmodel3Key] }}
                </option>
                <option *ngFor="let submodel3 of submodels3| keyvalue" [value]="submodel3.key">
                  {{submodel3.value}}
                </option>
              </select>
            </div>
            <ng-container *ngIf="showCategory">
              <div class="select-group my-3" *ngFor="let dropdown of mmysubCategoriesDropDownData; let i = index">
                <select name="{{dropdown.selected}}" class="vehicle-select form-select" [(ngModel)]="dropdown.selected"
                  (change)="fetchSubCategoryData(dropdown,i)" [ngClass]="{'completed': dropdown.selected }">
                  <option value=""> Category</option>
                  <option *ngFor="let category of dropdown?.data" [value]="category.category_key">
                    {{category.name}}
                  </option>
                </select>
              </div>
            </ng-container>
            <div class="banner-actions my-3 d-flex ">
              <button class="clear-red-btn" type="button" (click)="clearVehicle()">Clear</button>
              <button type="button" *ngIf="!chTheme12" class="btn-red-go" [disabled]="isSearchDisabled()" (click)="onSearchVehicle()">GO
                <img *ngIf="!chTheme14" src="/assets/images/uschiptuning/red-next-img.png" class="img-fluid ps-2" alt="icon"> </button>
                <button type="button" *ngIf="chTheme12" class="btn-red-go" [disabled]="isSearchDisabled()" (click)="onSearchVehicle()">Search </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</ng-template>

